// @ts-nocheck
import { useState } from "react";
import {createPortal} from "react-dom";
import { saveAs } from "file-saver";
import { useUiStore } from "src/components/main/uiStore";
//--------------------------------------------------------------------------------------------
import FileIcon from "src/components/common/fileIcons";
import Popover from "src/components/common/popover";
import { ReactComponent as Upload } from "src/img/svg/upload.svg";
import {
    mimeTypeMap, 
    myAxios, 
    MyDate, 
    objectReducer, 
    fileSystemSchemaForProjects, 
    post_max_size,
    validateEmail
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function FileSystem({ 
    item, 
    fileSystem,  
    setItems, 
    sqlTable, 
    itemLabel, 
    idLabel, 
    filesKey, 
    singleFolderId, 
    readOnly, 
    className,
    onFilesChanged
}:{
    item: any,
    fileSystem: {
        title: string,
        folderIdLabel: string,
        folderKey: string,
    }[],
    setItems: Function,
    sqlTable: string,
    itemLabel: string,
    idLabel: string,
    filesKey: string,
    singleFolderId?: string,
    readOnly?: boolean,
    className?: string,
    onFilesChanged?: () => void | Promise<void>,
}){
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const getFolderTitle = (folderIdLabel, fallbackTitle = "") =>
        fileSystem.find(folder => folder.folderIdLabel === folderIdLabel)?.title ??
        fileSystemSchemaForProjects.find(schema => schema.folderIdLabel === folderIdLabel)?.title ??
        fallbackTitle;
    // item: [idLabel], [filesKey], [singleFolderId], potholingForm, forms, jobTag
    //--------------------------------------------------------------------------------------------
    const hashKeyValue = item[idLabel];
    const totalFolderFiles = singleFolderId?
    (item[filesKey] ?? []).filter(file => 
        !file.name.includes(".sketch.json") && 
        !file.name.includes(".sign.json") && 
        !file.name.includes(".sign2.json") && 
        !file.name.includes(".signs.json") && 
        file.mimeType !== "application/vnd.google-apps.document" && 
        file.mimeType !== "application/vnd.google-apps.spreadsheet"
    )
    :
    {
        ...item[filesKey],
        ...Object.entries(item[filesKey])
        .map(([key, value]) => (
            {
                [key]: Array.isArray(value)?
                value.filter(file => 
                    !file.name.includes(".sketch.json") && 
                    !file.name.includes(".sign.json") && 
                    !file.name.includes(".sign2.json") && 
                    !file.name.includes(".signs.json") && 
                    file.mimeType !== "application/vnd.google-apps.document" && 
                    file.mimeType !== "application/vnd.google-apps.spreadsheet"
                )
                :
                value
            }
        )).reduce(objectReducer)
    };
    //--------------------------------------------------------------------------------------------
    const [selectedIndexesStrings, setSelectedIndexesStrings] = useState([]);
    const [switching, setSwitching] = useState(false);
    const [contextMenu, setContextMenu] = useState({show: false});
    const handleSystemFilesInput = async (
        e,  
        setItems, 
        idLabel, 
        filesKey, 
        sqlTable
    ) => {
        const target = e.currentTarget;
        const files = target.files;
        if(files.length === 0){
            target.value = "";
            return;
        }
        let size = 0;
        if(files.length === 1){
            size = files[0].size;
            if(files[0].size < 100 * 1024){
                if(!window.confirm(`The file size (${(files[0].size / 1024).toFixed(2)}k) is too small (less than 100k). Are you sure to upload?\n(Images can be selected as Medium or Large for better quality.)`)){
                    target.value = "";
                    return;
                }
            }
        }else if(files.length > 1){
            for(const file of files){
                size += file.size;
                if(file.size < 100 * 1024){
                    if(!window.confirm(`One of the file size (${(file.size / 1024).toFixed(2)}k) is too small (less than 100k). Are you sure to upload?\n(Images can be selected as Medium or Large for better quality.)`)){
                        target.value = "";
                        return;
                    }
                }
            }
        }
        if(size > post_max_size){
            const upload_size_in_M = Math.round(size / 1024 / 1024 * 100) / 100;
            const post_max_size_in_M = Math.round(post_max_size / 1024 / 1024);
            if(!window.confirm(`Upload size (${upload_size_in_M}M) exceed max allowable size ${post_max_size_in_M}M. Still Proceed? (This may cause error.)`)){
                target.value = "";
                return;
            }
        }
        const formData = new FormData();
        const hashKeyValue =  e.hashkey || e.currentTarget.getAttribute("hashkey");
        formData.append(idLabel, hashKeyValue);
        const folderId = e.currentTarget.getAttribute("inputfolderid");
        const folderIdLabel = e.currentTarget.getAttribute("inputfolderidroot");
        if(folderId !== ""){
            formData.append("folderId", folderId);
        }else{
            formData.append("folderIdLabel", folderIdLabel);
            formData.append("folderName", getFolderTitle(folderIdLabel, "Files"));
        }
        formData.append("targetFiles", e.folderkey || e.currentTarget.getAttribute("folderkey") || "");
        for(let fileToUpload of e.currentTarget.files){
            formData.append("files[]", fileToUpload);
        }
        formData.append("sqlTable", sqlTable);
        formData.append("idLabel", idLabel);
        formData.append("filesKey", filesKey);
        //-------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios({ fileName: "common/createAttachment.php", formData: formData });
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------------------
        setItems(items => items.map(p => ({
            ...p, [filesKey]:
            (p[idLabel] === hashKeyValue?
            (res.data?.[filesKey] ?? res.data?.files ?? res.data)
            :p[filesKey]
            ),
            [folderIdLabel]:
            (p[idLabel] === hashKeyValue?
                ((folderId === null || folderId === "") ? (res.data?.[folderIdLabel] ?? res.data?.folderId ?? p[folderIdLabel]) : p[folderIdLabel]) : p[folderIdLabel]
            )
        })));
        await onFilesChanged?.();
        target.value = "";
    }
    //--------------------------------------------------------------------------------------------
    return(
        <div>
            {fileSystem.map((folder, folderIndex) =>
            <div key = {folderIndex} className = {"maxWidth-100" + (className? " " + className : "")}>
                <div className = "fileSystemStyle mb-1">
                    {folder.title}
                </div>
                <div
                    hashkey = {hashKeyValue}
                    folderkey = {folder.folderKey}
                    totalfolderfiles = {JSON.stringify(totalFolderFiles)}
                    folderidlabel = {folder.folderIdLabel}
                    folderid = {
                        singleFolderId?
                        item[singleFolderId]
                        :
                        (totalFolderFiles[folder.folderIdLabel] ?? "")
                    }
                    className = "position-relative rounded border p-4 mb-2"
                    onContextMenu = {e => {
                        e.preventDefault();
                        e.stopPropagation();
                        setSelectedIndexesStrings([]);
                        setContextMenu({show: false});
                    }}
                    onClick = {e => {
                            e.preventDefault();
                            e.stopPropagation();
                            setSelectedIndexesStrings([]);
                            setContextMenu({show: false});
                    }}
                    onDragOver = {e => {
                        e.stopPropagation();
                        e.preventDefault();
                        e.currentTarget.classList.remove("white-bg");
                        e.currentTarget.classList.add("primary-bg");
                    }} 
                    onDragLeave = {e => {
                        e.stopPropagation();
                        e.preventDefault();
                        e.currentTarget.classList.remove("primary-bg");
                        e.currentTarget.classList.add("white-bg");
                    }}
                    onDrop = {async e => {
                        e.preventDefault();
                        e.stopPropagation();
                        e.currentTarget.classList.remove("primary-bg");
                        e.currentTarget.classList.add("white-bg");
                        if(readOnly){
                            window.alert("Permission denied.");
                            return;
                        }
                        if(switching){
                            // **** change file(s) parent ****
                            if(!e.dataTransfer.getData("hashkey")){
                                window.alert("Don't drop text here!");
                                return;
                            }
                            const newFileName = e.currentTarget.getAttribute("folderkey");
                            const oldFileNames = JSON.parse(e.dataTransfer.getData("folderkey"));
                            const fileIds = JSON.parse(e.dataTransfer.getData("fileid"));
                            const oldFolderIds = JSON.parse(e.dataTransfer.getData("oldfolderids"));
                            const newFolderId = e.currentTarget.getAttribute("folderid");
                            const formData = new FormData();
                            const indexes = [];
                            for(let [oldFileNameIndex, oldFileName] of oldFileNames.entries()){
                                if(oldFileName !== newFileName){
                                    indexes.push(oldFileNameIndex);
                                    formData.append("oldFileName[]", oldFileName);
                                }
                            }
                            if(!indexes.length){
                                return;
                            }
                            for(let oldFolderId of indexes.map(index => oldFolderIds[index])){
                                formData.append("oldFolderId[]", oldFolderId);
                            }
                            for(let fileId of indexes.map(index => fileIds[index])){
                                formData.append("fileId[]", fileId);
                            }
                            formData.append("idLabel", idLabel);
                            formData.append(idLabel, e.dataTransfer.getData("hashkey"));
                            formData.append("newFileName", newFileName);
                            if(newFolderId !== ""){
                                formData.append("newFolderId", newFolderId);
                            }else{
                                const folderIdLabel = e.currentTarget.getAttribute("folderidlabel");
                                formData.append("newFolderName", getFolderTitle(folderIdLabel, folder.folderKey || "Files"));
                            }
                            formData.append("sqlTable", sqlTable);
                            formData.append("filesKey", filesKey);
                            //-------------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "common/changeFileParent.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //-------------------------------------------------------------
                            setSelectedIndexesStrings([]);
                            setContextMenu({show: false});
                            setItems(items => items.map(p => ({
                                ...p, [filesKey]: (p[idLabel] === hashKeyValue?
                                (res.data?.[filesKey] ?? res.data?.files ?? res.data)
                                :p[filesKey])
                            })));
                            await onFilesChanged?.();
                        }else{
                            // **** create new file(s) ****
                            const formData = new FormData();
                            formData.append(idLabel, hashKeyValue);
                            formData.append("folderId", singleFolderId?item[singleFolderId]:(totalFolderFiles[folder.folderIdLabel] ?? ""));
                            formData.append("targetFiles", folder.folderKey || "");
                            for(let fileToUpload of e.dataTransfer.files){
                                formData.append("files[]", fileToUpload);
                            }
                            formData.append("sqlTable", sqlTable);
                            formData.append("idLabel", idLabel);
                            formData.append("filesKey", filesKey);
                            //-------------------------------------------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "common/createAttachment.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //-------------------------------------------------------------
                            setItems(items => items.map(p => ({
                                ...p, [filesKey]:(p[idLabel] === hashKeyValue?
                                (res.data?.[filesKey] ?? res.data?.files ?? res.data)
                                :p[filesKey])
                            })));
                            await onFilesChanged?.();
                        }
                    }}
                >
                    {(singleFolderId?totalFolderFiles:totalFolderFiles[folder.folderKey] || [])
                    .length?
                    (singleFolderId?totalFolderFiles:totalFolderFiles[folder.folderKey])
                    
                    .map((file, fileIndex) => 
                    <Popover 
                        key = {fileIndex}
                        fullContent = {<span>{file.name}</span>}
                        content = { 
                        <figure
                            className = "rounded p-2"
                            style = {{
                                backgroundColor: (selectedIndexesStrings.includes(JSON.stringify([folderIndex, fileIndex]))?"rgb(202,219,235)":null)
                            }}
                            onContextMenu = {e => {
                                if(selectedIndexesStrings.length === 0 || !selectedIndexesStrings.includes(JSON.stringify([folderIndex, fileIndex]))){
                                    setSelectedIndexesStrings([JSON.stringify([folderIndex, fileIndex])]);
                                }
                                e.preventDefault();
                                e.stopPropagation();
                                setContextMenu(
                                    {...contextMenu, 
                                    show: true, 
                                    top:  e.clientY + window.scrollY,
                                    left:  e.clientX + window.scrollX,
                                    folderFiles: totalFolderFiles,
                                });
                            }}
                            onDoubleClick = {() => {window.open(file.webViewLink);}}
                            onClick = {e => {
                                e.preventDefault();
                                e.stopPropagation();
                                setContextMenu({show: false});
                                if(e.ctrlKey){
                                    if(selectedIndexesStrings.includes(JSON.stringify([folderIndex, fileIndex]))){
                                        setSelectedIndexesStrings(selectedIndexesStrings.filter((value => value !== JSON.stringify([folderIndex, fileIndex]))));
                                    }else{
                                        setSelectedIndexesStrings([...selectedIndexesStrings, JSON.stringify([folderIndex, fileIndex])]);
                                    }
                                }else{
                                    setSelectedIndexesStrings([JSON.stringify([folderIndex, fileIndex])]);
                                }
                                setContextMenu(
                                    {...contextMenu, 
                                    show: true, 
                                    top:  e.clientY + window.scrollY,
                                    left:  e.clientX + window.scrollX,
                                    folderFiles: totalFolderFiles,
                                });
                            }}
                        >
                            <FileIcon 
                                fileid = {file.id}
                                draggable = {!readOnly}
                                onDragStart = {e => {
                                    // **** change file(s) parent ****
                                    setSwitching(true);
                                    if(selectedIndexesStrings.length > 1){
                                        const parent = e.currentTarget.parentNode.parentNode.parentNode;
                                        const totalFolderFilesString = parent.getAttribute("totalfolderfiles");
                                        const totalFolderFiles = JSON.parse(totalFolderFilesString);
                                        e.dataTransfer.setData("hashkey", parent.getAttribute("hashkey"));
                                        e.dataTransfer.setData("totalfolderfiles", totalFolderFilesString);
                                        e.dataTransfer.setData(
                                            "folderkey", 
                                            JSON.stringify(
                                                [
                                                    parent.getAttribute("folderkey"),
                                                    ...selectedIndexesStrings.map(selectedIndexesString => 
                                                        fileSystem[
                                                            JSON.parse(selectedIndexesString)[0]
                                                        ].folderKey
                                                    )
                                                ]
                                            )
                                        );
                                        e.dataTransfer.setData(
                                            "oldfolderids", 
                                            JSON.stringify(
                                                [
                                                    parent.getAttribute("folderid"),
                                                    ...selectedIndexesStrings.map(selectedIndexesString => 
                                                        singleFolderId?item[singleFolderId]:
                                                        totalFolderFiles[
                                                            fileSystem[
                                                                JSON.parse(selectedIndexesString)[0]
                                                            ].folderIdLabel
                                                        ]
                                                    )
                                                ]
                                            )
                                        );
                                        e.dataTransfer.setData(
                                            "fileid", 
                                            JSON.stringify(
                                                [e.currentTarget.getAttribute("fileid"), ...selectedIndexesStrings.map(selectedIndexesString => 
                                                    totalFolderFiles[
                                                        fileSystem[JSON.parse(selectedIndexesString)[0]].folderKey
                                                    ][
                                                        JSON.parse(selectedIndexesString)[1]
                                                    ].id
                                                )]
                                            )
                                        )
                                        setSelectedIndexesStrings([...selectedIndexesStrings, JSON.stringify([folderIndex, fileIndex])]);
                                    }else{
                                        const parent = e.currentTarget.parentNode.parentNode.parentNode;
                                        e.dataTransfer.setData("hashkey", parent.getAttribute("hashkey"));
                                        e.dataTransfer.setData("totalfolderfiles", parent.getAttribute("totalfolderfiles"));
                                        e.dataTransfer.setData("folderkey",JSON.stringify([parent.getAttribute("folderkey")]));
                                        e.dataTransfer.setData("oldfolderids", JSON.stringify([parent.getAttribute("folderid")]));
                                        e.dataTransfer.setData("fileid", JSON.stringify([e.currentTarget.getAttribute("fileid")]));
                                        setSelectedIndexesStrings([JSON.stringify([folderIndex, fileIndex])]);
                                    }
                                    e.currentTarget.parentNode.nextElementSibling.classList.remove("show");
                                    e.dataTransfer.setDragImage(e.currentTarget.parentNode, 0, 0)
                                }}
                                onDragEnd = {() => {
                                    setSwitching(false);
                                }}
                                fileType = {file.name.split(".").pop()}
                            />
                            <figcaption>{file.name.substring(0, 6) + "..."}</figcaption>
                        </figure>}
                    />
                    ):"None"}
                </div>
                {!readOnly?
                <div>
                    <label
                        tabIndex = {0}
                        htmlFor = {`uploadItemFiles ${itemLabel} ${folderIndex}`}
                        className = "mb-0 btn btn-primary"
                        onKeyDown = {e => {
                            if([" ", "Enter"].includes(e.key)){
                                e.preventDefault();
                                document.getElementById(`uploadItemFiles ${itemLabel} ${folderIndex}`).click();
                            }
                        }}
                    >
                        <Upload/>
                        &nbsp;&nbsp;&nbsp;Upload
                    </label>
                    <input 
                        id = {`uploadItemFiles ${itemLabel} ${folderIndex}`} 
                        type = "file" 
                        className = "nodisplay"
                        multiple 
                        hashkey = {hashKeyValue}
                        folderkey = {folder.folderKey}
                        totalfolderfiles = {JSON.stringify(totalFolderFiles)}
                        inputfolderid = {singleFolderId?item[singleFolderId]:(totalFolderFiles[folder.folderIdLabel] ?? "")}
                        inputfolderidroot = {singleFolderId?singleFolderId:folder.folderIdLabel}
                        onChange = {e => handleSystemFilesInput(
                            e, 
                            setItems, 
                            idLabel, 
                            filesKey, 
                            sqlTable, 
                        )}
                    />
                </div>
                :null}
            </div>)
            }
            {contextMenu.show?
            <MyContextMenu 
            {...contextMenu} 
            selectedIndexesStrings = {selectedIndexesStrings}
            setSelectedIndexesStrings = {setSelectedIndexesStrings}
            hashKeyValue = {hashKeyValue}
            idLabel = {idLabel}
            filesKey = {filesKey}
            sqlTable = {sqlTable}
            fileSystem = {fileSystem}
            setContextMenu = {setContextMenu}
            setItems = {setItems}
            singleFolderId = {singleFolderId}
            item = {item}
            readOnly = {readOnly}
            onFilesChanged = {onFilesChanged}
            />:null}
        </div>
    );
}
function MyContextMenu({
    sqlTable, 
    filesKey, 
    hashKeyValue, 
    top, 
    left, 
    folderFiles, 
    idLabel, 
    selectedIndexesStrings, 
    setSelectedIndexesStrings, 
    fileSystem, 
    setContextMenu, 
    setItems, 
    singleFolderId, 
    item, 
    readOnly,
    onFilesChanged
}){
    const setShowLoader = useUiStore(state => state.setShowLoader);
    return createPortal(
        <div
            className = "contextMenu position-absolute"
            style = {{
                top: top, 
                left: left,
            }}
        >
            <div
                onClick = {() => {
                    for(let selectedIndexesString of selectedIndexesStrings){
                        window.open(
                            (
                                singleFolderId?
                                folderFiles
                                :
                                folderFiles[fileSystem[JSON.parse(selectedIndexesString)[0]].folderKey]
                            )[JSON.parse(selectedIndexesString)[1]].webViewLink
                        );
                    }
                    setSelectedIndexesStrings([]);
                    setContextMenu({show: false});
                }}
            >
                View
            </div>
            <div onClick = {async() => {
                const formData = new FormData();
                for(let selectedIndexesString of selectedIndexesStrings){
                    formData.append("fileId[]", 
                    (
                        singleFolderId?
                        folderFiles
                        :
                        folderFiles[fileSystem[JSON.parse(selectedIndexesString)[0]].folderKey]
                    )[JSON.parse(selectedIndexesString)[1]].id);
                }
                const uniqFileNames = []
                for(let selectedIndexesString of selectedIndexesStrings){
                    const fileName = (
                        singleFolderId?
                        folderFiles
                        :
                        folderFiles[fileSystem[JSON.parse(selectedIndexesString)[0]].folderKey]
                    )
                    [JSON.parse(selectedIndexesString)[1]].name;
                    if(!uniqFileNames.includes(fileName)){
                        uniqFileNames.push(fileName);
                        formData.append("fileName[]", fileName);
                    }else{
                        const fileNameArr = fileName.split(".");
                        const fileExt = fileNameArr.pop();
                        const filePre = fileNameArr.join();
                        const newFileName = `${filePre} - copy.${fileExt}`;
                        uniqFileNames.push(newFileName);
                        formData.append("fileName[]", newFileName);
                    }
                }
                //-------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios({ fileName: "common/getAttachment.php", formData: formData, responseType: "blob" });
                setShowLoader(false);
                if(!res) return;
                //-------------------------------------------------------------
                setSelectedIndexesStrings([]);
                setContextMenu({show: false});
                if(selectedIndexesStrings.length > 1){
                    const file = new Blob([res.data],{type: mimeTypeMap.zip});
                    saveAs(file, `Files downloaded on ${(new MyDate()).s()}`);
                }else if(selectedIndexesStrings.length === 1){
                    const file = new Blob([res.data], {
                        type: (singleFolderId?
                            folderFiles
                            :
                            folderFiles[fileSystem[JSON.parse(selectedIndexesStrings[0])[0]].folderKey]
                        )[JSON.parse(selectedIndexesStrings[0])[1]].mimeType
                    });
                    saveAs(file, 
                        (
                            singleFolderId?
                            folderFiles
                            :
                            folderFiles[fileSystem[JSON.parse(selectedIndexesStrings[0])[0]].folderKey]
                        )[JSON.parse(selectedIndexesStrings[0])[1]].name);
                }
            }}>
                Download
            </div>
            <div onClick = {async() => {
                let toEmail = window.prompt("Email Address:");
                if(toEmail === null) return;
                while(toEmail === "" || !validateEmail(toEmail)){
                    window.alert("Input not valid.");
                    toEmail = window.prompt("Email Address:");
                    if(toEmail === null) return;
                }
                const formData = new FormData();
                formData.append("toEmail", toEmail);
                for(let selectedIndexesString of selectedIndexesStrings){
                    formData.append("fileId[]", 
                    (
                        singleFolderId?
                        folderFiles
                        :
                        folderFiles[fileSystem[JSON.parse(selectedIndexesString)[0]].folderKey]
                    )[JSON.parse(selectedIndexesString)[1]].id);
                }
                const uniqFileNames = []
                for(let selectedIndexesString of selectedIndexesStrings){
                    const fileName = (
                        singleFolderId?
                        folderFiles
                        :
                        folderFiles[fileSystem[JSON.parse(selectedIndexesString)[0]].folderKey]
                    )
                    [JSON.parse(selectedIndexesString)[1]].name;
                    if(!uniqFileNames.includes(fileName)){
                        uniqFileNames.push(fileName);
                        formData.append("fileName[]", fileName);
                    }else{
                        const fileNameArr = fileName.split(".");
                        const fileExt = fileNameArr.pop();
                        const filePre = fileNameArr.join();
                        const newFileName = `${filePre} - copy.${fileExt}`;
                        uniqFileNames.push(newFileName);
                        formData.append("fileName[]", newFileName);
                    }
                }
                //-------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios({ fileName: "common/emailAttachments.php", formData: formData });
                setShowLoader(false);
                if(!res) return;
                //-------------------------------------------------------------
                setSelectedIndexesStrings([]);
                setContextMenu({show: false});
            }}>
                Email
            </div>
            {readOnly?null:<div onClick = {async() => {
                if(!window.confirm("are you sure to delete this file?")) return;
                const formData = new FormData();
                formData.append(idLabel, hashKeyValue);
                for(let selectedIndexesString of selectedIndexesStrings){
                    const id = (singleFolderId?folderFiles:folderFiles[fileSystem[JSON.parse(selectedIndexesString)[0]].folderKey])[JSON.parse(selectedIndexesString)[1]].id;
                    if(item.jobSafetyAnalysisTemplate === id){
                        window.alert("This PDF is related to an ative JSA form, thus cannot be deleted.");
                        setSelectedIndexesStrings([]);
                        setContextMenu({show: false});
                        return;
                    }
                    if(item.multiJSA && JSON.parse(item.multiJSA).find(jsa => jsa.jobSafetyAnalysisTemplate === id)){
                        window.alert("This PDF is related to an ative Multi Site JSA form, thus cannot be deleted.");
                        setSelectedIndexesStrings([]);
                        setContextMenu({show: false});
                        return;
                    }
                    if(JSON.parse(item.potholingForm ?? "[]").map(p => p.id).includes(id)){
                        window.alert("This PDF is related to an ative potholing form, thus cannot be deleted.");
                        setSelectedIndexesStrings([]);
                        setContextMenu({show: false});
                        return;
                    }
                    if(JSON.parse(item.forms ?? "[]").map(p => p.id).includes(id)){
                        const form = JSON.parse(item.forms ?? "[]").find(p => p.id === id);
                        window.alert(`This PDF is related to an ative ${form.form}, thus cannot be deleted.`);
                        setSelectedIndexesStrings([]);
                        setContextMenu({show: false});
                        return;
                    }
                    if(item.jobTag === id){
                        window.alert(`This PDF is related to an ative job tag, thus cannot be deleted.`);
                        setSelectedIndexesStrings([]);
                        setContextMenu({show: false});
                        return;
                    }
                    formData.append("fileId[]", id);
                }
                for(let selectedIndexesString of selectedIndexesStrings){
                    const folderId = singleFolderId?item[singleFolderId]:
                    folderFiles[fileSystem[JSON.parse(selectedIndexesString)[0]].folderIdLabel];
                    formData.append("folderId[]", folderId);
                }
                if(!singleFolderId){
                    for(let selectedIndexesString of selectedIndexesStrings){
                        formData.append("folderName[]", fileSystem[JSON.parse(selectedIndexesString)[0]].folderKey);
                    }
                }
                formData.append("sqlTable", sqlTable);
                formData.append("idLabel", idLabel);
                formData.append("filesKey", filesKey);
                //-------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios({ fileName: "common/deleteAttachment.php", formData: formData });
                setShowLoader(false);
                if(!res) return;
                //-------------------------------------------------------------
                setSelectedIndexesStrings([]);
                setContextMenu({show: false});
                setItems(items => items.map(p => ({...p, [filesKey]:(p[idLabel] === hashKeyValue?
                (res.data?.[filesKey] ?? res.data?.files ?? res.data)
                :p[filesKey])})));
                await onFilesChanged?.();
            }}>
                Delete
            </div>}
            <div onClick = {() => {
                setContextMenu({show: false});
                setSelectedIndexesStrings([]);
            }}>
                Cancel
            </div>
        </div>, document.getElementById("app-root")
    );
}
